import { FC, PropsWithChildren } from "react";
import { twMerge } from "tailwind-merge";

export type SlideOverWrapperProps = PropsWithChildren<{
  className?: string;
}>

export const SlideOverWrapper: FC<SlideOverWrapperProps> = ({ children, className }) => {
  return <div className={twMerge('h-full flex flex-col bg-white-100 shadow-xl px-6', className)}>{children}</div>;
};